<div *ngIf="long_description" class="description">
    <div class="py-1 lh flex">
        <p>
            <span
                [innerHTML]="long_description"
                class="details-font shop-details"
            ></span>
        </p>
    </div>
</div>